(function () {
  var bar = document.querySelector("[data-ts-purchase-bar]");
  if (!bar || !window.matchMedia || !window.IntersectionObserver) return;

  var realButton = document.querySelector("[data-product-form-regular] [data-product-atc]");
  var barButton = bar.querySelector("[data-ts-purchase-bar-button]");
  var barPrice = bar.querySelector("[data-ts-purchase-bar-price]");
  var barInc = bar.querySelector("[data-ts-purchase-bar-inc]");
  var barNote = bar.querySelector("[data-ts-purchase-bar-note]");
  var pricing = document.querySelector("[data-product-pricing]");
  var selection = document.querySelector("[data-variant-selection]");
  if (!realButton || !barButton) return;

  var narrow = window.matchMedia("(max-width: 749px)");
  var choose = bar.getAttribute("data-ts-choose") || "";

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function variantChosen() {
    if (!selection) return true;
    var value = selection.getAttribute("variant");
    return Boolean(value && value !== "not-selected");
  }

  function buttonLabel() {
    var label = realButton.querySelector(".atc-button--text");
    return text(label || realButton);
  }

  function sync() {
    var chosen = variantChosen();
    if (barPrice) barPrice.textContent = chosen ? text(pricing && pricing.querySelector(".excl_vat")) : "";
    if (barInc) barInc.textContent = chosen ? text(pricing && pricing.querySelector(".incl_vat")) : "";
    if (barNote) {
      barNote.textContent = chosen
        ? text(document.querySelector('.ts-buy-panel-wrapper[data-stock-variant-selected="true"] .ts-buy-panel__title'))
        : choose;
    }
    var label = chosen ? buttonLabel() : choose || buttonLabel();
    var labelNode = barButton.querySelector(".atc-button--text");
    if (label && labelNode) labelNode.textContent = label;
    var unavailable = chosen && (realButton.disabled || realButton.classList.contains("disabled"));
    barButton.disabled = unavailable;
    barButton.classList.toggle("disabled", unavailable);
  }

  function showBar(show) {
    var visible = show && narrow.matches;
    bar.hidden = !visible;
    document.documentElement.classList.toggle("ts-purchase-bar-on", visible);
  }

  var wrapper = document.querySelector("[data-product-form-regular] .product-form__action-wrapper");
  var sentinel = document.querySelector("[data-ts-buybox-sentinel]");

  var spacer = null;

  function holdSpace(active) {
    if (active) {
      if (spacer || wrapper.classList.contains("ts-buybox-docked")) return;
      var style = window.getComputedStyle(wrapper);
      var height = wrapper.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
      spacer = document.createElement("div");
      spacer.setAttribute("aria-hidden", "true");
      spacer.setAttribute("data-ts-buybox-spacer", "");
      spacer.style.cssText = "flex:none;width:100%;height:" + height + "px;";
      wrapper.parentNode.insertBefore(spacer, wrapper);
    } else if (spacer) {
      spacer.parentNode.removeChild(spacer);
      spacer = null;
    }
  }

  function dock(on) {
    if (!wrapper) return;
    var active = Boolean(on && narrow.matches);
    holdSpace(active);
    wrapper.classList.toggle("ts-buybox-docked", active);
    document.documentElement.classList.toggle("ts-buybox-docked", active);
    if (active) showBar(false);
  }

  var observer = new IntersectionObserver(function (entries) {
    var onScreen = entries.some(function (entry) { return entry.isIntersecting; });
    if (sentinel) {
      dock(!onScreen);
      showBar(false);
    } else {
      showBar(!onScreen);
    }
  }, { threshold: 0, rootMargin: "0px 0px -8px 0px" });

  barButton.addEventListener("click", function () {
    if (!variantChosen()) {
      var options = document.querySelector("[data-options-selection]");
      if (options) options.scrollIntoView({ block: "center", behavior: "smooth" });
      return;
    }
    if (barButton.disabled) return;
    realButton.click();
  });

  var hint = null;

  function promptForVariant() {
    var options = document.querySelector("[data-options-selection]");
    if (!options) return;
    var firstUnset = options.querySelector("select[data-variant-option] option[value='not-selected']:checked");
    var select = firstUnset ? firstUnset.parentNode : options.querySelector("select");
    var labelNode = select && select.id ? options.querySelector('label[for="' + select.id + '"]') : null;
    var name = labelNode && labelNode.getAttribute("data-variant-option-name");
    if (!hint) {
      hint = document.createElement("p");
      hint.className = "ts-variant-hint";
      hint.setAttribute("role", "alert");
      options.insertBefore(hint, options.firstChild);
    }
    hint.textContent = name ? "Choose a " + name + " first" : "Choose an option first";
    options.classList.add("ts-variant-needed");
    options.scrollIntoView({ block: "center", behavior: "smooth" });
    if (select && select.focus) {
      try { select.focus({ preventScroll: true }); } catch (e) { select.focus(); }
    }
  }

  function clearHint() {
    if (hint) hint.textContent = "";
    var options = document.querySelector("[data-options-selection]");
    if (options) options.classList.remove("ts-variant-needed");
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest("[data-product-form-regular] [data-product-atc]")) return;
    if (variantChosen()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    promptForVariant();
  }, true);

  if (pricing) {
    new MutationObserver(sync).observe(pricing, { childList: true, characterData: true, subtree: true });
  }
  if (selection) {
    new MutationObserver(function () { sync(); if (variantChosen()) clearHint(); }).observe(selection, { attributes: true, attributeFilter: ["variant"] });
  }
  new MutationObserver(sync).observe(realButton, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["disabled", "class"]
  });

  function buttonOffScreen() {
    var rect = realButton.getBoundingClientRect();
    return rect.bottom <= 0 || rect.top >= window.innerHeight - 88;
  }

  function watch() {
    if (!narrow.matches) {
      dock(false);
      showBar(false);
      return;
    }
    sync();
    observer.observe(sentinel || realButton);
    if (sentinel) {
      var rect = sentinel.getBoundingClientRect();
      dock(rect.bottom <= 0 || rect.top >= window.innerHeight);
      showBar(false);
    } else {
      showBar(buttonOffScreen());
    }
  }

  if (narrow.addEventListener) narrow.addEventListener("change", watch);
  else if (narrow.addListener) narrow.addListener(watch);

  sync();
  watch();
})();
